// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2643) return "static/css/2643.c143b9c27f166d769af2.css";
	if (chunkId === 8958) return "static/css/sender.b9e5c2fbaa2322950312.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"638":"ea9798e5fd931e89d597","6559":"b2e5d3c087a7fdcef4f6","8261":"0d9e2e5a42015dec09e1"}[chunkId] + ".chunk.css";
};